/*
 Copyright (c) 2026. BrightNight. All rights reserved.
 Unauthorized copying of this file, via any medium is strictly prohibited.
 Proprietary and confidential.
 */

import type { AbsoluteURL, PrefectFlow, ServiceName } from '@poweralpha/common';

export const flowNameToLogURL: Record<PrefectFlow, AbsoluteURL> = {
  'ESS only Project': '/ess/costing/logs',
  'PV only Project': '/projects',
  'PV+ESS Project': '/projects',
  'ESS Only Batch': '/projects',
  'PV Only Batch': '/projects',
  'PV+ESS Batch': '/projects',
  PlantSim: '/plant/logs',
  'PlantSim v2': '/plant-v2/logs',
  'PlantSim v2 Batch': '/plant-v2/logs',
  'PlantSim Batch': '/plant/logs',
  'PlantSim Net Benefit': '/plant/logs',
  'PlantSim v2 Net Benefit': '/plant-v2/logs',
  'PVSim weather from API': '/db/logs',
  'Solar Resource Report': '/db/logs',
  'PVSim simulate energy': '/pv/logs',
  'PVCosting only': '/pv/logs',
  'ESS Costing only, Li-ion': '/ess/costing/logs',
  'Add Price Curves': '/db/logs',
  'Energy Scoring': '/projects',
  'METSAT Fleet Report': '/db/logs',
  'Update BRWF Eng Results': '/projects', // won't be used
  METCAP: '/db/logs',
  METSAT: '/db/logs',
  'METSAT PVSim Comparison': '/db/logs',
  METSOIL: '/db/logs',
};

export const serviceNameToResultURL: Record<keyof ServiceName, AbsoluteURL> = {
  pv_sim: '/pv/pvsim/results',
  pv_costing: '/pv/costing/simulate',
  ess_costing: '/ess/costing/simulate',
  plant_sim: '/plant/results',
  plant_sim_v2: '/plant-v2/results',
  plant_sim_v2_batch: '/plant-v2/batch/results',
  plant_sim_batch: '/plant/batch/results',
  plant_sim_net_benefit: '/plant/net-benefit',
  project: '/projects',
  metcap: '/db/met-stations',
};
